module.exports = __webpack_public_path__ + "img/190.93330d28.jpg";